import { createComparingLifecycle } from "./lifecycle";
export function onWillReceiveProps(callback) {
    return createComparingLifecycle("componentWillReceivePropsCallback", callback);
}
export default onWillReceiveProps;

//# sourceMappingURL=onWillReceiveProps.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/onWillReceiveProps.js
// module id = 61
// module chunks = 0